import { render, staticRenderFns } from "./CopyConfirm.vue?vue&type=template&id=3c48bac6"
import script from "./CopyConfirm.vue?vue&type=script&lang=js"
export * from "./CopyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports